export enum CircleButtonColorEnum {
  blue = 'blue',
  red = 'red',
  green = 'green',
  purple = 'purple',
}
